






































































































import { defineComponent, PropType, ref } from '@vue/composition-api'
import IconButton from '~/components/IconButton.vue'
import FlatTable from '~/components/FlatTable.vue'
import ViewCrudDialog from '~/components/ViewCrudDialog.vue'
import ViewFilter from '~/components/ViewFilter.vue'
import { tableComposition } from '~/compositions/table'
import { ApiController, GetterFunction } from '~/utils/classes/ApiController'
import { Iterable, Params, TableHeader, VueTable } from '~/utils/interfaces'
import FlatCard from './FlatCard.vue'
import TableSwitch from './TableSwitch.vue'
import TextButton from './TextButton.vue'
export default defineComponent({
  components: {
    FlatTable,
    IconButton,
    ViewCrudDialog,
    ViewFilter,
    TableSwitch,
    TextButton,
    FlatCard,
  },
  props: {
    modelName: { type: String, default: '' },
    headers: {
      type: Array as PropType<TableHeader[]>,
      required: true,
    },
    controller: {
      type: Object as PropType<ApiController>,
      //   required: props => !props.getter,
    },
    getterFunction: {
      type: Function as PropType<GetterFunction<any>>,
    },
    defaultCrud: {
      type: Object,
    },
    serializeFilter: {
      type: Function as PropType<(filter: Iterable) => Iterable>,
      default: (filter: Iterable) => filter,
    },
    hideFilter: Boolean,
    createEditFunction: {
      type: Function,
    },
    crudMaxWidth: {
      type: String,
      default: '400',
    },
    disableIsActive: {
      type: Function,
      default: function() {
        return false
      },
    },
    disableEdit: {
      type: Function,
      default: function() {
        return false
      },
    },
    disableCopy: {
      type: Function,
      default: function() {
        return false
      },
    },
    hideCreate: Boolean,
    noValidate: Boolean,
    validateFunction: {
      type: Function as PropType<() => Promise<boolean>>,
      default: () => true,
    },
    rejectFunction: {
      type: Function as PropType<() => Promise<boolean>>,
      default: () => true,
    },
    itemClass: {
      type: Function as PropType<() => string>,
    },
    acceptText: String,
    cancelText: String,
  },
  // @ts-ignore
  setup(props) {
    const dialog = ref()

    const resetFormValidation = () => {
      dialog.value?.resetFormValidation()
    }

    if (props.controller) {
      const composition = tableComposition(props.controller)
      return {
        ...composition,
        getter: props.getterFunction || composition.getter,
        dialog,
        resetFormValidation,
      }
    }

    if (props.getterFunction) {
      const table = ref<VueTable>()
      return {
        getter: props.getterFunction,
        table,
        onRefresh: () => table.value?.refresh(),
        newFilter: (filter: Params) => table.value?.newFilter(filter),
        resetFormValidation,
        dialog,
      }
    }
  },
})
